import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import * as React from "react";
import {useTheme} from "@mui/material/styles";

export default function SelectedItemsFilters({children}: { children: React.ReactNode }) {
    const theme = useTheme()

    return (
        <Box
            display = "flex" alignItems = "center" justifyContent = "center"
            position = "absolute" right = {32} left = {32} bottom = {{xs: 16, md: -86}}
            height = {80}
            zIndex = {5000}
        >
            <Paper
                elevation = {6}
                sx = {{
                    maxWidth: theme.breakpoints.values['sm'],
                    width: '100%',
                    py: 2,
                    boxShadow: 'none'
                }}
            >
                {children}
            </Paper >
        </Box >
    )
}